import { render, staticRenderFns } from "./PurchaseOrderBulkDeleteBar.vue?vue&type=template&id=5b2588c3&scoped=true"
import script from "./PurchaseOrderBulkDeleteBar.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrderBulkDeleteBar.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseOrderBulkDeleteBar.vue?vue&type=style&index=0&id=5b2588c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2588c3",
  null
  
)

export default component.exports